/**
 * LocationPermissionManager Component
 *
 * Automatically triggers browser's native location permission prompt
 * on first visit or after login. Uses browser's built-in alert style
 * (like "Google wants to access your location")
 *
 * No custom UI - just the native browser prompt
 */

import { useEffect } from "react";
import useLocation from "../hooks/useLocation";
import logger from "../utils/logger";

const LocationPermissionBanner = () => {
  const { shouldRequestPermission, requestLocation } = useLocation();

  useEffect(() => {
    // Automatically trigger native browser prompt on first visit
    if (shouldRequestPermission) {
      logger.log("Triggering native location permission prompt...");

      // Small delay to let the app load first
      const timer = setTimeout(() => {
        requestLocation();
      }, 2000); // 2 second delay after app loads

      return () => clearTimeout(timer);
    }
  }, [shouldRequestPermission, requestLocation]);

  // No UI - just the native browser prompt
  return null;
};

export default LocationPermissionBanner;
